const config = {
    //DOMAIN_NAME_SANRITSU: 'tokyo-sanritsu.com.vn'
    // DOMAIN_NAME_SANRITSU: 'localhost:8082'
  };

export default config;



//////////////////
// WEBPACK FOOTER
// ./env.js
// module id = 77eN
// module chunks = 4